import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Animation, Icon, TooltipWrapper } from '@zapier/design-system';
const Styles = labelStyles('SearchTogglerOutOfApp', {
    root: css `
    width: 40px;
    height: 40px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--zds-gray-warm-6, #88827e);
    transition: ${Animation.transitionValue};

    &:hover,
    &:focus {
      background-color: transparent;
      color: var(--zds-gray-warm-10, #201515);
    }
  `,
});
const SearchToggler = (props) => {
    return (jsx(TooltipWrapper, { content: props.label, position: "south", shouldCorrectPosition: false, showTooltipOnTouchDevices: false }, () => (jsx("label", { "aria-hidden": props.ariaHidden, "aria-label": props.ariaLabel, css: Styles.root, htmlFor: props.id, "data-zds": true },
        jsx(Icon, { name: props.isSearching ? 'formX' : 'navSearch', size: 24 })))));
};
export default SearchToggler;
//# sourceMappingURL=SearchToggler.js.map
// @zapier/universal-layout@11.0.60 (de4647366)
